import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Contact Information */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact</h3>
            <div className="space-y-3">
              <div>
                <p className="font-semibold">ASDA Genève</p>
                <div className="flex items-start mt-2">
                  <MapPin className="h-5 w-5 mr-2 mt-1 flex-shrink-0" />
                  <div>
                    <p>C/o La Mobilière Genève</p>
                    <p>Route du Grand-Lancy 6A</p>
                    <p>1227 Les Acacias</p>
                  </div>
                </div>
              </div>
              <div className="flex items-center">
                <Mail className="h-5 w-5 mr-2" />
                <div>
                  <a href="https://www.asdage.ch" className="hover:text-blue-400 block">
                    www.asdage.ch
                  </a>
                  <a href="mailto:geneve@asda.ch" className="hover:text-blue-400 block">
                    geneve@asda.ch
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Liens rapides</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="hover:text-blue-400">
                  À propos
                </Link>
              </li>
              <li>
                <Link to="/join" className="hover:text-blue-400">
                  Devenir membre
                </Link>
              </li>
              <li>
                <Link to="/careers" className="hover:text-blue-400">
                  Carrières
                </Link>
              </li>
              <li>
                <Link to="/partners" className="hover:text-blue-400">
                  Partenaires
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Légal</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/legal" className="hover:text-blue-400">
                  Mentions légales
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="hover:text-blue-400">
                  Politique de confidentialité
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-gray-800 text-center">
          <p className="text-sm text-gray-400">
            © {new Date().getFullYear()} ASDA Genève. Tous droits réservés.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;